import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { treatments } from "@/data/treatments";
import Reveal from "@/components/Reveal";

// Selezione in evidenza sulla home (l'elenco completo è in /trattamenti)
const featured = treatments.slice(0, 8);

const Treatments = () => {
  return (
    <section id="trattamenti" className="py-24 bg-secondary/30">
      <div className="container mx-auto px-4">
        <Reveal className="text-center max-w-2xl mx-auto mb-14">
          <p className="eyebrow">I Trattamenti</p>
          <h2 className="mt-3 font-serif text-4xl md:text-6xl text-primary">
            Un gesto di cura per te
          </h2>
          <p className="mt-5 text-lg text-foreground/80 leading-relaxed">
            Scopri l'ampia gamma di trattamenti ayurvedici e olistici, fra i quali
            scegliere accuratamente per portare equilibrio e benessere nella tua vita.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {featured.map((treatment, i) => (
            <Reveal key={treatment.slug} delay={(i % 4) * 80}>
              <Link to={`/trattamenti/${treatment.slug}`} className="group block h-full">
                <article className="h-full bg-card rounded-2xl overflow-hidden border border-border shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={treatment.image}
                      alt={treatment.name}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-5">
                    <h3 className="font-serif text-2xl text-primary group-hover:text-accent transition-colors">
                      {treatment.name}
                    </h3>
                    <p className="mt-2 text-sm text-foreground/75 leading-relaxed line-clamp-3">
                      {treatment.short}
                    </p>
                  </div>
                </article>
              </Link>
            </Reveal>
          ))}
        </div>

        <div className="text-center mt-14">
          <Button asChild size="lg" className="text-base px-8 py-6 rounded-full">
            <Link to="/trattamenti">
              Scopri tutti i {treatments.length} trattamenti
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Treatments;
